export default __webpack_public_path__ + "static/media/information--lane-control-intersections--g1.7a491f54.png";